export const HEAD_INPUT = "HEAD_INPUT";
export const HEAD_DATE = "HEAD_DATE";